import { render, staticRenderFns } from "./CommentsBillCreate.vue?vue&type=template&id=50447abc&scoped=true&"
import script from "./CommentsBillCreate.vue?vue&type=script&lang=js&"
export * from "./CommentsBillCreate.vue?vue&type=script&lang=js&"
import style0 from "./CommentsBillCreate.vue?vue&type=style&index=0&id=50447abc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50447abc",
  null
  
)

export default component.exports